import { SerializedError } from '@reduxjs/toolkit';
import { TErrorResponse } from '~/store/types.ts';
import { errorMessages } from '~/constants/errorMessages.ts';
import { TRemoteBankingContactsStore } from '~/store/remote-banking-contacts/types.ts';

export const remoteBankingContactsFulfilled = (state: TRemoteBankingContactsStore) => {
  state.loading = false;
  state.error = null;
  state.status = '';
};

export const remoteBankingContactsPending = (state: TRemoteBankingContactsStore) => {
  state.loading = true;
};

export const remoteBankingContactsError = (
  state: TRemoteBankingContactsStore,
  action: { error: SerializedError; payload?: TErrorResponse | unknown }
) => {
  state.loading = false;
  state.error = (action.payload as TErrorResponse)?.message || errorMessages.SERVICE_UNAVAILABLE;
};

export const verifyContrAgentError = (
  state: TRemoteBankingContactsStore,
  action: { error: SerializedError; payload?: TErrorResponse | unknown }
) => {
  state.loading = false;
  state.error =
    (action.payload as TErrorResponse)?.message || errorMessages.SERVICE_UNAVAILABLE_TRY_AGAIN;
};
